<div class="home">
    <img src="assets/img/NAL-Logo-Landscape.png">
    <p>{{message}}</p>
    @if(code === '409' && memberId !== null) {
         <button class="next-btn" (click)="downloadCard()">REDOWNLOAD CARD</button>
    }
</div>